<nb-card>
  <nb-card-body>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <h6 class="text-primary link" (click)="viewDetail(loan)">
            <nb-icon icon="person-outline"></nb-icon>
            {{ loan.customerName }}
          </h6>

          <a
            *ngIf="loan.customer?.mobile"
            class="text-hint link"
            href="tel:{{ loan.customer.mobile }}"
          >
            <nb-icon icon="phone-call-outline"></nb-icon>
            {{ loan.customer.mobile }}
          </a>

          <label *ngIf="loan.customer?.address" class="text-hint">
            <nb-icon icon="map-outline"></nb-icon>
            {{ loan.customer.address }}
          </label>
        </div>

        <div class="content">
          <h6 class="text-primary link" (click)="viewDetail(loan)">
            <nb-icon icon="car-outline"></nb-icon>
            {{ loan.productName }}
          </h6>

          <label *ngIf="loan.product?.barcode" class="text-hint">
            <nb-icon icon="hash-outline"></nb-icon>
            {{ loan.product.barcode }}
          </label>

          <label class="text-hint">
            <nb-icon icon="calendar-outline"></nb-icon>
            <span class="text-hint"> Ngày nhận: </span>
            <b>{{ loan.issueDate | date : "dd/MM/yyyy" }}</b>
            <ngx-view-time-ago
              [currentDate]="loan.issueDate"
            ></ngx-view-time-ago>
          </label>

          <label class="text-hint">
            <nb-icon icon="calendar-outline"></nb-icon>
            <span> Ngày đáo hạn: </span>
            <b class="text-basic">{{
              loan.remindDate | date : "dd/MM/yyyy"
            }}</b>
            <ngx-view-time-ago
              [currentDate]="loan.remindDate"
            ></ngx-view-time-ago>
          </label>

          <label class="text-hint">
            <nb-icon icon="eye-outline"></nb-icon>
            <span> Hình thức đáo hạn: </span>
            <b class="text-basic">{{ remindTypeName }} </b>
            <b class="text-info">${{ loan.remindAmount | number }} </b>
          </label>

          <div>
            <h6 class="text-hint">
              <nb-icon icon="pricetags-outline"></nb-icon>
              Thu:
              <span class="text-info">{{ loan.totalPaidAmount | number }}</span>
              / Chi:
              <span class="text-primary">{{ loan.detailAmount | number }}</span>
              / Còn lại:
              <span class="text-success">
                {{ loan.detailAmount - loan.totalPaidAmount | number }}</span
              >
            </h6>
          </div>

          <label class="text-hint">
            <nb-icon
              [icon]="loan.isClosed ? 'lock-outline' : 'unlock-outline'"
              [status]="loan.isClosed ? 'success' : 'warning'"
            ></nb-icon>
            <b [ngClass]="loan.isClosed ? 'text-success' : 'text-warning'"
              >{{ loan.isClosed ? "Kết thúc giao dịch" : "Đang giao dịch" }}
            </b>
          </label>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
